import { Account, ContactPerson } from '@lemontaps/lib/types/api';
import useTierInfo from './useTierInfo';
import React, { useEffect, useState } from 'react';
import { getContactPersons } from '../apis/account';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppSelector } from '@/application/hooks';

const ContactPersonsContext = React.createContext<ContactPerson[]>([]);

export const ContactPersonsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [contactPersons, setContactPersons] = useState<ContactPerson[]>([]);
  const { getAccessTokenSilently } = useAuth0();
  const { isStarter } = useTierInfo();
  const account: Account = useAppSelector(state => state.account);

  useEffect(() => {
    if (isStarter || !account?.id) return;
    getContactPersons(getAccessTokenSilently).then(setContactPersons).catch(console.error);

    //Retrigger if account changes
  }, [getAccessTokenSilently, isStarter, account]);

  return (
    <ContactPersonsContext.Provider value={contactPersons}>
      {children}
    </ContactPersonsContext.Provider>
  );
};

export const useContactPersons = () => {
  const context = React.useContext(ContactPersonsContext);
  if (context === undefined) {
    throw new Error('useContactPersons must be used within a ContactPersonsProvider');
  }
  return context;
};
